import React from 'react';
import PropTypes from 'prop-types';
import {Formik} from 'formik';
import Step1View from './Step1-view';
import {loadOptionsByDDType} from '../../actions/loadOptionsByDDType';
import {checkRequiredValues} from '../../utils/forms/checkRequiredValues';
import {ddTypes} from '../../constants/dropdownTypes';
import {checkNextStepAndGo} from '../../utils/checkNextStepAndGo';
import types from '../../types';
import {trackEvent} from "../../utils/trackEvent";
import {useIntl} from "react-intl";

const Step1 = ({
                 submitStep,
                 regType,
                 language,
                 payload,
                 prevCompletedStepSign,
                 prevCompletedStepSignFalse,
               }) => {
  const {mainCategoryId} = payload;

  const initialValues = {
    category: (mainCategoryId) ? {value: mainCategoryId} : '',
  };

  const validate = values => {
    let errors = {};

    errors = checkRequiredValues(values, errors);

    return errors
  };

  const {formatMessage} = useIntl();

  const handleSubmit = values => {
    const {category: {value: mainCategoryID}} = values;

    submitStep({
      step: 1,
      data: {
        regType,
        mainCategoryID,
        prevCompletedStepSign,
      },
    })
      .then(checkNextStepAndGo)
      .then(() => prevCompletedStepSignFalse())
      .then(() => trackEvent('signup_step',
          {
            step_number: 1,
            step_name_en: 'Joining the service',
            step_name_he: formatMessage({id: 'step1.page.title', defaultMessage: ''}),
            regType
          }
        )
      )
      .catch(err => console.log({err}));
  };

  const loadOptions = (inputValue, callback) => {
    loadOptionsByDDType({callback, language, ddType: ddTypes.mainCategoryItems})
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validate={validate}
      enableReinitialize={true}
      validateOnChange={true}
      validateOnBlur={false}
    >
      {({isValid, submitCount}) => (
        <Step1View
          loadOptions={loadOptions}
          isValid={isValid || submitCount === 0}
        />
      )}
    </Formik>
  )
};

Step1.propTypes = {
  ...types.router,
  regType: PropTypes.string,
  language: PropTypes.string,
  submitStep: PropTypes.func
};

export default Step1;
